import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import * as tus from "tus-js-client";
import { UtilisateurService } from './utilisateur.service';
import { KeycloakUtilisateurService } from './keycloak/keycloak-utilisateur.service';

@Injectable({
  providedIn: 'root'
})
export class UploadGeotiffService {
  private readonly _uploadEnCours = new Subject<number[]>();
  private readonly _uploadReussi = new Subject<boolean>();
  private readonly _uploadEchec = new Subject<boolean>();
  enCours$ = this._uploadEnCours.asObservable();
  reussi$ = this._uploadReussi.asObservable();
  echec$ = this._uploadEchec.asObservable();

  constructor(private readonly utilService: UtilisateurService, private readonly keycloakUtilisateurService: KeycloakUtilisateurService) { }

  uploadGeotiff(fichier: File, poids: number, nom: string, ordre: number) {
    const upload = new tus.Upload(fichier, {
      endpoint: 'api/geotiffUpload',
      retryDelays: [0, 3000, 5000, 10000, 20000],
      metadata: {
        filename: nom,
        userId: this.keycloakUtilisateurService.userId,
        siteId: this.utilService.currentSite().siteId.toString(),
        ordre: ordre.toString(),
        poids: poids.toString()
      },
      chunkSize: 5000000,
      onError: (error) => this._uploadEchec.next(true),
      onProgress: (bytesUploaded, bytesTotal) => this._uploadEnCours.next([bytesUploaded, bytesTotal]),
      onSuccess: () => this._uploadReussi.next(true)
    });
    upload.start();
  }
}
